export { DocumentsTab, documentsRightRail } from './DocumentsTab';
